<div id="{{appName}}" class="container-fluid" class="{{theme}}">
    <div class="content" style="height: fit-content;"> 
        <app-loader></app-loader>
        <mat-toolbar class="admin-header">
            <mat-toolbar-row>
                <span>
                    <a class="nav-link home" [routerLink]="['/admin']">
                        <img alt="Home" class="ct-logo" [src]="commonService.commonFiles['admin-logo']" alt="Admin-Logo">
                    </a>
                </span>
                <span class="nav-link-inner header-text-{{ this.selectedApp.value }}">
                        <a class="nav-link home" [routerLink]="['/admin']">
                            Telematics ADMIN Portal
                        </a>
                </span>
                <div>

                </div>


                <div class="toolbar-external-icons-container">
                    <ul class="admin-dropdown-item">
                        <li class="nav-item app-dropdown-menu">
                            <button class="btn btn-default" [matMenuTriggerFor]="belowMenu">
                                {{seletedMenu.controlName}}
                                <span class="fa fa-caret-down"></span>
                            </button>
                            <mat-menu #belowMenu="matMenu" yPosition="below">
                                <div *ngFor="let item of menuList">
                                    <button *ngIf="item.url" mat-menu-item (click)="menuSelection(item)">{{item.controlName}}</button>
                                    <button *ngIf="!item.url" mat-menu-item [matMenuTriggerFor]="submenu">{{item.controlName}}</button>
                                    <mat-menu #submenu="matMenu" yPosition="below">
                                        <div *ngFor="let subItem of item.subMenu">
                                            <button mat-menu-item (click)="menuSelection(subItem)">{{ subItem.controlName }}</button>
                                        </div>
                                    </mat-menu>
                                </div>
                            </mat-menu>
                        </li>
                    </ul>
                    <ul class="admin-dropdown-item">
                        <li class="nav-item app-dropdown-menu">
                            <div class="dropdown app-dropdown-menu">
                                <button type="button" class="btn dropdown-toggle" data-toggle="dropdown">
                                    <img style="background-color: white;" alt="Lexus" (click)="onchangeApp(applist[0]);" *ngIf="this.selectedApp.value === 'lexus'" class="ct-logo-lexus" [src]="lexLogo">
                                    <img style="background-color: white;" alt="Toyota" (click)="onchangeApp(applist[1]);" *ngIf="this.selectedApp.value === 'toyota'" class="ct-logo-toyota" [src]="toyLogo">
                                </button>
                                <div class="dropdown-menu">
                                    <a class="dropdown-item" *ngFor="let app of applist">
                                        <span (click)="onchangeApp(app);" class="sidebar-text cursor-pointer">
                                            <span>
                                                <img [alt]="selectedApp" class="cursor-pointer app-list-icon" [ngClass]="{'icon-lexus': app.name === 'Lexus','icon-toyota': app.name === 'Toyota'}"
                                                    src="{{app.icon}}">
                                            </span>
                                            <span>{{app.name}}</span>
                                        </span>
                                    </a>
                                </div>
                            </div>
                        </li>
                    </ul>
                    <ul class="admin-dropdown-item">
                        <li class="nav-item app-dropdown-menu">
                            <button type="button" class="btn" [matMenuTriggerFor]="belowUserMenu">
                                <img alt="user" class="user-icon" [src]="commonService.commonFiles['avatar']">
                            </button>
                            <mat-menu #belowUserMenu="matMenu" yPosition="below">
                                <button mat-menu-item>{{getName()}}</button>
                                <button mat-menu-item (click)="onLogout()">Logout</button>
                            </mat-menu>
                        </li>

                    </ul>
                </div>
            </mat-toolbar-row>
        </mat-toolbar>

        <mat-sidenav-container>
            <mat-sidenav #landingSideNav *ngIf="(router.url == '/admin' || router.url == '/admin/feature' || router.url == '/admin/flow')"
                [ngClass]="isSideNavOpen ? 'side-bar-container' : 'side-bar-close'" mode="side" opened>
                <div  style="height: 40px;">
                    <button class="side-nav-toggle-button" (click)="toggleSideNavBar()" style="border: none; border-radius: 5%;z-index: 2;" 
                    [ngStyle]="{'background-color' : getSideNavToggleButtonBackground()}">
                        <mat-icon style="width: 29px; height: 29px; font-size: 29px;">menu</mat-icon>
                    </button>

                </div>
                <div  *ngIf="!isSideNavOpen" style="height: 40px;">
                    <button class="side-nav-search-button" (click)="toggleSideNavBar('search')" style="border: none; border-radius: 5%;background-color: white">
                        <mat-icon style="width: 29px; height: 29px; font-size: 29px; " [ngStyle]="{'color' : this.selectedApp.value === 'lexus' ? '#B6A171' : '#CC0000'}">search</mat-icon>
                    </button>
                </div>
                <div *ngIf="isSideNavOpen">
                    <mat-button-toggle-group class="toggle-group" name="fontStyle" aria-label="Font Style" #contentType=ngModel [(ngModel)]="featureContentStatus" style="width:100%;">
                        <mat-button-toggle value="published" style="width : 50%;" (change)="onValChange($event.value)">PUBLISHED</mat-button-toggle>
                        <mat-button-toggle value="draft" style="width : 50%;" (change)="onValChange($event.value)">DRAFT</mat-button-toggle>
                    </mat-button-toggle-group>
                </div>
                <div *ngIf="isSideNavOpen">
                    <input #sideNavSearch type="text" placeholder="Search support topics" (input)="filterChanged($event.target.value)" (keyup.enter)="filterChanged($event.target.value)" style="width : 100%; height: 4em;">
                </div>
                <div class="tree-block" *ngIf="isSideNavOpen">
                    <mat-accordion #featureAccordion="matAccordion" multi="true">
                        <mat-expansion-panel [expanded]="dataSource.contentTypes[0].isExpanded" ngDefaultControl #internalSupportTopicPanel="matExpansionPanel"
                            (opened)="beforeFeaturePanelOpened('internal')" [ngStyle]="{'background': dataSource.contentTypes[0].isExpanded ? '#CC0' : '#22282D'}">
                            <mat-expansion-panel-header expandedHeight="50px" collapsedHeight="50px">
                                INTERNAL
                            </mat-expansion-panel-header>
                            <mat-tree [dataSource]="dataSource" [treeControl]="treeControl">
                                <mat-tree-node *matTreeNodeDef="let node" matTreeNodePadding matTreeNodePaddingIndent="15" [ngClass]="{'tree-active-menu' : node.activeNode}"
                                    (click)="onNodeSelection(node)">
                                    <button mat-icon-button disabled>
                                        <mat-icon class="tree-icons leaf-node-icon">
                                            fiber_manual_record
                                        </mat-icon>
                                    </button>
                                    {{node.item.controlName}}
                                    <sup class="feature-status" *ngIf="node.item.status=='draft'"> {{node.item.status}}</sup>
                                </mat-tree-node>
                                <mat-tree-node [ngClass]="{'tree-active-menu' : node.activeNode}" (click)="onNodeSelection(node)" *matTreeNodeDef="let node; when: hasChild"
                                    matTreeNodePadding matTreeNodePaddingIndent="15">
                                    <button (click)="this.focusSearch = false;" [disabled]="node.isLoading" mat-icon-button [attr.aria-label]="'toggle ' + node.filename" matTreeNodeToggle>
                                        <mat-icon class="tree-icons">
                                            {{treeControl.isExpanded(node) ? 'arrow_drop_down' : 'arrow_right'}}
                                        </mat-icon>
                                    </button>
                                    {{node.item.controlName}}
                                    <sup class="feature-status" *ngIf="node.item.status=='draft'"> {{node.item.status}}</sup>
                                    <mat-progress-bar *ngIf="node.isLoading" mode="indeterminate" class="example-tree-progress-bar"></mat-progress-bar>
                                </mat-tree-node>
                            </mat-tree>
                        </mat-expansion-panel>

                        <mat-expansion-panel [expanded]="dataSource.contentTypes[1].isExpanded" [ngStyle]="{'background': dataSource.contentTypes[1].isExpanded ? '#CC0' : '#22282D'}"
                            ngDefaultControl #externalSupportTopicPanel="matExpansionPanel" (opened)="beforeFeaturePanelOpened('external')">
                            <mat-expansion-panel-header expandedHeight="50px" collapsedHeight="50px">
                                EXTERNAL
                            </mat-expansion-panel-header>
                            <mat-tree [dataSource]="dataSource" [treeControl]="treeControl">
                                <mat-tree-node *matTreeNodeDef="let node" matTreeNodePadding matTreeNodePaddingIndent="15" [ngClass]="{'tree-active-menu' : node.activeNode}"
                                    (click)="onNodeSelection(node)">
                                    <button mat-icon-button disabled>
                                        <mat-icon class="tree-icons leaf-node-icon">
                                            fiber_manual_record
                                        </mat-icon>
                                    </button>
                                    {{node.item.controlName}}
                                    <sup class="feature-status" *ngIf="node.item.status=='draft'"> {{node.item.status}}</sup>
                                </mat-tree-node>
                                <mat-tree-node [ngClass]="{'tree-active-menu' : node.activeNode}" (click)="onNodeSelection(node)" *matTreeNodeDef="let node; when: hasChild"
                                    matTreeNodePadding matTreeNodePaddingIndent="15">
                                    <button (click)="this.focusSearch = false;" [disabled]="node.isLoading" mat-icon-button [attr.aria-label]="'toggle ' + node.filename" matTreeNodeToggle>
                                        <mat-icon class="tree-icons">
                                            {{treeControl.isExpanded(node) ? 'arrow_drop_down' : 'arrow_right'}}
                                        </mat-icon>
                                    </button>
                                    {{node.item.controlName}}
                                    <sup class="feature-status" *ngIf="node.item.status=='draft'"> {{node.item.status}}</sup>
                                    <mat-progress-bar *ngIf="node.isLoading" mode="indeterminate" class="example-tree-progress-bar"></mat-progress-bar>
                                </mat-tree-node>
                            </mat-tree>
                        </mat-expansion-panel>
                    </mat-accordion>
                </div>
            </mat-sidenav>
            <mat-sidenav *ngIf="(router.url == '/admin/vehicle' || router.url == '/admin/addVehicle')" class="side-bar-container" mode="side"
                opened>
                <div class="d-flex">
                    <span class="p-2 bold">FILTERS</span>
                    <span class="p-2 bold ml-auto mr-2" style="font-size: 16px; color: rgba(255, 255, 255, 0.55); cursor: pointer;">Clear All</span>
                    <!-- add hover color to the spans -->
                </div>
                <mat-accordion>

                    <mat-expansion-panel>
                        <mat-expansion-panel-header [@.disabled]="true" expandedHeight="50px" collapsedHeight="50px">
                            <mat-panel-title>

                                <span class="p-2">CLASSIFICATION</span>
                            </mat-panel-title>
                        </mat-expansion-panel-header>

                        <div *ngIf="adminService.vehicleClassification.length>0" class="">
                            <mat-selection-list #classificationList (selectionChange)="classificationFilterChange($event)">

                                <mat-list-option [value]="vehicle" disableRipple="true" *ngFor="let vehicle of adminService.vehicleClassification | filterUnique; last as isLast; first as isFirst"
                                    checkboxPosition="before" style="color: white;">
                                    {{vehicle}}
                                </mat-list-option>
                            </mat-selection-list>
                        </div>
                    </mat-expansion-panel>
                </mat-accordion>
                <mat-accordion>
                    <mat-expansion-panel>
                        <mat-expansion-panel-header [@.disabled]="true" expandedHeight="50px" collapsedHeight="50px">
                            <mat-panel-title>
                                <span class="p-2">MODEL</span>
                            </mat-panel-title>
                        </mat-expansion-panel-header>
                        <div>
                            <mat-selection-list #modelList (selectionChange)="modelFilterChange($event)">

                                <mat-list-option [value]="vehicle.model" disableRipple="true" *ngFor="let vehicle of adminService.filterdModelList; last as isLast; first as isFirst"
                                    checkboxPosition="before" style="color: white;">
                                    {{vehicle.model}}
                                </mat-list-option>
                            </mat-selection-list>
                        </div>
                    </mat-expansion-panel>
                </mat-accordion>
                <mat-accordion>
                    <mat-expansion-panel>
                        <mat-expansion-panel-header [@.disabled]="true" expandedHeight="50px" collapsedHeight="50px">
                            <mat-panel-title>
                                <span class="p-2">YEAR</span>
                            </mat-panel-title>
                        </mat-expansion-panel-header>
                        <div>
                            <mat-selection-list #yearList (selectionChange)="yearFilterChange($event)">

                                <mat-list-option [value]="year" disableRipple="true" *ngFor="let year of adminService.yearList; last as isLast; first as isFirst"
                                    checkboxPosition="before" style="color: white;">
                                    {{year}}
                                </mat-list-option>
                            </mat-selection-list>
                        </div>
                    </mat-expansion-panel>
                </mat-accordion>

                <mat-accordion>
                    <mat-expansion-panel>
                        <mat-expansion-panel-header [@.disabled]="true" expandedHeight="50px" collapsedHeight="50px">
                            <mat-panel-title>
                                <span class="p-2">GENERATION</span>
                            </mat-panel-title>
                        </mat-expansion-panel-header>
                        <div>
                            <mat-selection-list #generationList (selectionChange)="generationFilterChange($event)">

                                <mat-list-option [value]="generation" disableRipple="true" *ngFor="let generation of adminService.generationList; last as isLast; first as isFirst"
                                    checkboxPosition="before" style="color: white;">
                                    {{generation}}
                                </mat-list-option>
                            </mat-selection-list>
                        </div>
                    </mat-expansion-panel>
                </mat-accordion>



            </mat-sidenav>
            <mat-sidenav-content [ngStyle]="{ 'margin-left.px' : contentMargin}">
                <div *ngIf="(router.url == '/admin')" class="sidenav-content">
                    <app-publish-feature></app-publish-feature>
                </div>
                <div *ngIf="!(router.url == '/admin')" class="sidenav-content ">
                    <router-outlet> </router-outlet>
                </div>
            </mat-sidenav-content>
        </mat-sidenav-container>